// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"474":"aabb369b","985":"aabb369b"}[chunkId] + ".css";
};